<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
      <div class="footer-bottom">Copyright @2023 上海泊冉软件有限公司版权所有 沪ICP备13039056号</div>
  </div>
</template>

<script>
import axios from "axios";
export function uploadAction(url,parameter){
    return axios({
        url: url,
        data: parameter,
        method:'GET' ,
        headers: {
            'Content-Type': 'multipart/form-data',  // 文件上传
        },
    })
}
export default {
  name: 'App',
    data() {
        return {
        }
    },
    mounted() {
    },
    methods:{

    },
    beforeunload() {
      console.log('bbbbbbb---------------bbbbbbb')
    },
    created() {
      console.log(this.$route, 'ididididid');
        if (this.$route.meta.id) {
            uploadAction(`https://iboran.com/api.php/cms/sort/scode/${this.$route.meta.id}`).then(res => {
                document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.keywords)
                document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.description)
                document.title = res.data.data.title;
                this.$route.meta.title = res.data.data.title;
                this.$route.meta.content.keywords = res.data.data.keywords;
                this.$route.meta.content.description = res.data.data.description;
                console.log(this.$route, '$route.meta------ccccccccc--AAAAA---------$route.meta')
            }).catch(err => {
                alert(err.message)
            })
        }
    }
}
</script>

<style>
	*{margin: 0;padding: 0;}
    #app {
        /*min-width: 1080px;*/
        /*1190*/
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .footer-bottom {
        color: #6f6f6f;
        font-size: 16px;
        background: #f8f8f8;
        line-height: 80px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue